import ritualLogo from "@/assets/ritual-logo.png";
import { cn } from "@/lib/utils";

interface LogoProps {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  showText?: boolean;
  className?: string;
  textClassName?: string;
}

const sizeMap = {
  xs: "h-5 w-5",
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-10 w-10",
  xl: "h-12 w-12",
};

const textSizeMap = {
  xs: "text-sm",
  sm: "text-base",
  md: "text-lg",
  lg: "text-xl",
  xl: "text-2xl",
};

export function Logo({ 
  size = "md", 
  showText = true,
  className,
  textClassName
}: LogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <img 
        src={ritualLogo} 
        alt="Ritual" 
        className={cn(sizeMap[size], "object-contain")}
      />
      {showText && (
        <span className={cn("font-bold tracking-tight", textSizeMap[size], textClassName)}>
          Ritual
        </span>
      )}
    </div>
  );
}
